module.exports = __webpack_public_path__ + "static/POSTERIOR-bed04ff6956c4b69011e69cfda90a9ee.webp";